import {LOCATION_CHANGE} from "react-router-redux";

export const ADD_NOTIFICATION = 'takeback/ADD_NOTIFICATION';
export const CLEAR_NOTIFICATIONS = 'takeback/CLEAR_NOTIFICATIONS';

export default function reducer(state = {}, action = {}) {
    switch (action.type) {
    case ADD_NOTIFICATION:
        return state.merge(action.payload.type, action.payload.message);
    case CLEAR_NOTIFICATIONS:
        return state.set('success', []).set('error', []);
    case LOCATION_CHANGE:
        return state.set('success', []).set('error', []);
    default:
        return state;
    }
}

export function addNotification(type, message) {
    return { type: ADD_NOTIFICATION, payload: { type, message } };
}

export function clearNotifications() {
    return { type: CLEAR_NOTIFICATIONS };
}
